import type { FetchAllActivities } from './typings'
import type { ActivityDetails } from '../../../typings'

export const fetchAllActivities = (
  payload: ActivityDetails[],
): FetchAllActivities => ({
  type: 'activities/fetchAll',
  payload,
})
